const ON_CHANGE_DEBOUNCE_TIMER = 100;

let subscribers = {}
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) { subscribers[eventName] = [] }
  subscribers[eventName] = [...subscribers[eventName], callback];
  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => { return cb !== callback });
  }
};

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
  SetLoader() {
    //cl('{SetLoader}');
    $('.product__detail__info').addClass('js-ajax-loading-content');
    $('.product__detail__info').addClass('no-pe no-se');
    $('.product-form__buttons button.gl-button').addClass('gl-button__disabled disabled no-pe no-se');
    $('.product-form__buttons').addClass('cursor-disabled');
  }
  UnsetLoader() {
    //cl('{UnsetLoader}');
    $('.product__detail__info').removeClass('js-ajax-loading-content');
    $('.product__detail__info').removeClass('no-pe no-se');
    $('.product-form__buttons button.gl-button').removeClass('gl-button__disabled disabled no-pe no-se');
    $('.product-form__buttons').removeClass('cursor-disabled');
  }
  onVariantChange() {
    this.SetLoader();
    this.updateOptions();
    this.updateMasterId();

    if (!this.currentVariant) {
      //alert('{onVariantChange} !this.currentVariant '+this.currentVariant);
      this.setUnavailable();
      this.UnsetLoader();
    } else {
      this.renderProductInfo();
      this.updateURL();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    /*cl('[product-variants.js] updateOptions #57');*/
    /* var use_dropdown = 'dropdown'; */
    var use_dropdown = 'select';  
    if (use_dropdown == 'dropdown') { 
      this.options = $('.product__detail__info input[type="radio"]', this).map(function() { return this.value; }).get();
      console.log(this.options);
    } else {
      this.options = $('.product__detail__info .product__detail__variants select').map(function() { return this.value; }).get();
      console.log(this.options);
    }
  }
  updateMasterId() {
    /*cl('[product-variants.js] updateMasterId');*/
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateURL() {
    /*cl('[product-variants.js] updateURL');*/
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    var product_url = this.dataset.href;
    if (product_url != undefined && product_url !== 'false') {
      window.history.replaceState({ }, '', `${product_url}?variant=${this.currentVariant.id}`);
    }
  }
  updateShareUrl() {
    /*cl('[product-variants.js] updateShareUrl');*/
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    /*cl('[product-variants.js] setInputAvailability');*/
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }
  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;  
    var product_url = this.dataset.href;
    const get_url = `${product_url}?variant=${requestedVariantId}&section_id=${sectionId}`;
    /*cl('[product-variants.js] {renderProductInfo} get_url'+get_url);*/
    fetch(get_url)
      .then((response) => response.text())
      .then((responseText) => {
        /* prevent unnecessary ui changes from abandoned selections */
        if (this.currentVariant.id !== requestedVariantId) return;
        const response_html = new DOMParser().parseFromString(responseText, 'text/html');;
        
        /*
            js-update-product-info__price
            js-update-product-info__variants
            js-update-product-info__similair
            js-update-product-info__buttons
            js-update-product-info__details
            js-update-product-info__size
            js-update-product-info__fabric
            js-update-product-info__shipping
        */

        /*var swap_id = `product-info-${sectionId}`;*/
        var swap_id = `js-update-product-info__price`;
        var html_source = response_html.getElementById(swap_id);
        var html_destination = document.getElementById(swap_id);
        if (html_source && html_destination) {
          html_destination.innerHTML = html_source.innerHTML;
          html_destination.classList.toggle('visibility-hidden', html_source.innerText === '');
        }        
        var swap_id = `js-update-product-info__variants`;
        var html_source = response_html.getElementById(swap_id);
        var html_destination = document.getElementById(swap_id);
        if (html_source && html_destination) {
          html_destination.innerHTML = html_source.innerHTML;
          html_destination.classList.toggle('visibility-hidden', html_source.innerText === '');
        }
        var swap_id = `js-update-product-info__similair`;
        var html_source = response_html.getElementById(swap_id);
        var html_destination = document.getElementById(swap_id);
        if (html_source && html_destination) {
          html_destination.innerHTML = html_source.innerHTML;
          html_destination.classList.toggle('visibility-hidden', html_source.innerText === '');
        }          
        var swap_id = `js-update-product-info__buttons`;
        var html_source = response_html.getElementById(swap_id);
        var html_destination = document.getElementById(swap_id);
        if (html_source && html_destination) {
          html_destination.innerHTML = html_source.innerHTML;
          html_destination.classList.toggle('visibility-hidden', html_source.innerText === '');
        }          
        var swap_id = `js-update-product-info__details`;
        var html_source = response_html.getElementById(swap_id);
        var html_destination = document.getElementById(swap_id);
        if (html_source && html_destination) {
          html_destination.innerHTML = html_source.innerHTML;
          html_destination.classList.toggle('visibility-hidden', html_source.innerText === '');
        }
        var swap_id = `js-update-product-info__size`;
        var html_source = response_html.getElementById(swap_id);
        var html_destination = document.getElementById(swap_id);
        if (html_source && html_destination) {
          html_destination.innerHTML = html_source.innerHTML;
          html_destination.classList.toggle('visibility-hidden', html_source.innerText === '');
        }
        var swap_id = `js-update-product-info__qatc`;
        var html_source = response_html.getElementById(swap_id);
        var html_destination = document.getElementById(swap_id);
        if (html_source && html_destination) {
          html_destination.innerHTML = html_source.innerHTML;
          html_destination.classList.toggle('visibility-hidden', html_source.innerText === '');
        }  

        InitAddToCartButtons();
        InitProductAddCartSubmit();
        this.UnsetLoader();
      });
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`ProductForm-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
  }
  setUnavailable() {
    const button = document.getElementById(`ProductForm-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
if ( $('variant-selects').length ) { customElements.define('variant-selects', VariantSelects); }

class VariantRadios extends VariantSelects {
  constructor() { super(); }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    /*cl('[product-variants.js] setInputAvailability');*/
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }
  updateOptions() {
    /*cl('[product-variants.js] updateOptions #288');*/
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      /* return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value; */
      return $.makeArray($('input', fieldset)).find(function(radio) {
        return radio.checked;
      }).value;

    });
  }
}
if ( $('variant-radios').length ) { customElements.define('variant-radios', VariantRadios); }

